/* eslint-disable functional/no-conditional-statement */
import { useLanguageUrlParam } from "./useLanguageUrlParam";
import { getPartnerPathnameClient } from "../../getPartnerPathnameClient";
import { useIsPhrasesAPIErrorValue } from "../miscellaneous/useIsPhrasesAPIErrorValue";
import { useNavigate } from "./useNavigate";
import { parseCookie } from "../../payment/miscellaneous/parseCookie";

export function useIsNavigateErrorPage() {
  const navigate = useNavigate();
  const isPhrasesAPIError = useIsPhrasesAPIErrorValue();
  const langUrlParam = useLanguageUrlParam();
  const mkHcLoggedIn = parseCookie(document.cookie)["MkHcLoggedIn"];
  const mkHcLoggedInToken = parseCookie(document.cookie)["MkHcLoggedInToken"];

  if (mkHcLoggedIn && mkHcLoggedInToken === undefined) {
    navigate(`${getPartnerPathnameClient(true)}/login`);
  } else if (isPhrasesAPIError) {
    navigate(`${getPartnerPathnameClient(true)}/error${langUrlParam}`);
  }
}
